// extracted by mini-css-extract-plugin
export default {"title":"Registered_title__nIiPx","subtitle":"Registered_subtitle__AwT5I","text":"Registered_text__pGcw0"};